import { useAuth } from '../../context/auth-context'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import { MeetingsHistoryTableContainer } from './shared/MeetingsHistoryTableContainer'
import { useTranslation } from 'react-i18next'
import { NextMeetingTile } from '../dashboard/Tiles/Employee/NextMeetingTile'
import BackgroundBox from '../../components/custom_components/BackgroundBox'
import PerText from '../../components/custom_components/Text'
import useReplyerMeetingsAndRequests from '../../graphql/meeting/hooks/useReplyerMeetingsAndRequests'
import { useEmployeeLevels } from '../../graphql/employee/hooks/useEmployeeLevels'
import { Country, EmployeeLevelEnum } from '../../types'
import { MeetingRequestOptionsProvider } from '../../context/meeting-request-options-context'

export const EmployeeMeetingsContainer = (): JSX.Element => {
  const [t] = useTranslation()
  const { user } = useAuth()
  const { data, error, loading } = useReplyerMeetingsAndRequests(user.employeeId)
  const {
    employeeLevels,
    error: employeeLevelError,
    loading: employeeLevelLoading,
    hasEmployeeLevel,
  } = useEmployeeLevels(user.country as Country)

  const userCannotRequestMeetings = !hasEmployeeLevel(user.currentEmployeeLevel as EmployeeLevelEnum)

  if (
    loading ||
    employeeLevelLoading ||
    error ||
    employeeLevelError ||
    !data ||
    !data.meetingsByReplyer ||
    !data.getMeetingRequestsByRequester ||
    !employeeLevels
  ) {
    return (
      <LoadingAndErrors
        isLoading={loading || employeeLevelLoading}
        hasNoData={!data || !data.meetingsByReplyer || !data.getMeetingRequestsByRequester || !!employeeLevels}
        error={error || employeeLevelError}
      />
    )
  }

  return (
    <MeetingRequestOptionsProvider employeeId={user.employeeId}>
      {!userCannotRequestMeetings && (
        <BackgroundBox r mb="xs" height="infoBox" className="slick--mx-xxl">
          <PerText mb="m" appearance="tile-heading">
            {t('dashboard.shared.meetings.header')}
          </PerText>
          <NextMeetingTile
            meetingData={data.meetingsByReplyer}
            requestData={data.getMeetingRequestsByRequester}
            employeeView
            withManagerOptions={false}
          />
        </BackgroundBox>
      )}
      <MeetingsHistoryTableContainer
        employeeId={user.employeeId}
        light
        emptyTextType="request"
        userCannotRequestMeetings={userCannotRequestMeetings}
        view="EmployeeMeetingsContainer"
      />
    </MeetingRequestOptionsProvider>
  )
}
